<template lang="pug">
  app-modal(
    :titulo="titulo",
    :width="width"
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-pdf-viewer(
        v-if="bytes"
        :bytes = "bytes"
      )
    template(slot="footer")
      div.flex
        el-button(@click="downloadPdf")
          i.fal.fa-file-pdf
          span &nbsp Download PDF

</template>

<script>
import AppModal from '@/components/AppModal'
import AppPdfViewer from '@/components/AppPDFViewer'
import FileHelper from '@/utils/fileHelper'

export default {

  components: {
    AppModal,
    AppPdfViewer,
    FileHelper
  },

  props: {
    bytes: {
      type: ArrayBuffer
    },
    width: {
      type: Number,
      default: 1024
    },
    titulo: {
      type: String,
      required: true
    }
  },

  methods: {
    downloadPdf () {
      FileHelper.saveFile(this.bytes, this.titulo)
    }
  }
}

</script>

<style scoped lang="scss">

  p.message {
    width: 80%;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: flex-end;
  }

</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/AppModalVisualizarPdf.vue